import React from 'react';
import InputFields from './components/InputFields/InputFields';
import style from './Form.module.scss';

const Form: React.FC = () => {
	return (
		<div className={style.container} data-test="Form">
			<InputFields />
		</div>
	);
};

export default Form;
